import { Theme } from "@mui/material";
import { colors } from "../../constants/colors";
import zIndex from "@mui/material/styles/zIndex";

const styles = {
  height: "100%",
  '& .carousel-arrow': {
    backgroundColor: colors.primary,
    alignSelf: 'center',
    padding: 0,
    border: 'none',
    height: '24px',
    width: '24px',
    borderRadius: '50%',
    color: 'white',
    cursor: 'pointer',
  },
  '& .carousel-left-arrow': {
    marginRight: '0'
  },
  '& .carousel-right-arrow': {
    marginLeft: '0'
  },
  '& .carousel-dots': {
    height: 16,
    backgroundColor: colors.secondary,
    width: 16,
    borderRadius: "50%",
    border: 0,
    margin: '0 0.5rem',
    transition: 'background-color 0.3s ease'
  },
  '& .carousel-active-dot': {
    backgroundColor: colors.primary
  },
  '@media (min-width: 0)': {
    '& .carousel-left-arrow': {
      marginRight: '-4.5rem',
      zIndex: 10
    },
    '& .carousel-right-arrow': {
      marginLeft: '-4.5rem',
      zIndex: 10
    }
  }
};

const carouselStyles: any = (theme?: Theme) => styles;

export default carouselStyles;